export default "__VITE_ASSET__ad9ff6a0__"